export default "__VITE_ASSET__bb75746d__"